// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"50":"d9290f84","143":"d57d67e2","309":"19653a04","431":"a9581c02","516":"4f3870cd","788":"d1a01ab0"}[chunkId] + ".chunk.js";
};